import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  Body,
  DisplaySmall,
  ArrowPointLeft,
  borderRadius,
  color,
  elevation,
  palette,
  spacing,
  typography,
} from "@conserveit/blocks";

// Main Layout
// @ts-ignore
export const BackIcon = styled(ArrowPointLeft)`
  width: 20px;
  height: 20px;
  margin-right: ${spacing.snug};
  fill: ${palette.neutral7};
`;

export const GoBack = styled(Link)`
  text-decoration: none;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: ${borderRadius.large};
  box-shadow: ${elevation.content};
  background: ${color.pureWhite};
`;

export const Half = styled.div`
  flex-basis: 50%;
  max-width: 50%;
`;

export const OneThird = styled.div`
  flex-basis: calc(100% / 3);
  max-width: calc(100% / 3);
`;

export const TwoThirds = styled.div`
  flex-basis: calc(100% / 3 * 2);
  max-width: calc(100% / 3 * 2);
`;

export const ContentFooter = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  border-top: 1px solid ${color.theme.divider.solid};
  background-color: ${palette.neutral2};
  padding: ${spacing.snug};
`;

// All forms
export const ServerError = styled.p`
  text-align: right;
  padding: ${spacing.default};
  color: ${palette.red5};
`;

// View Action specific

// TODO: Bazaar
export const CommentContainer = styled.div`
  background-color: ${color.pureWhite};
  border-radius: ${borderRadius.default};
  margin-bottom: ${spacing.default};
  box-shadow: ${elevation.content};
  padding: ${spacing.snug};
`;

export const FieldSection = styled.section`
  padding: ${spacing.extraLoose};
  border-bottom: 1px solid ${color.theme.divider.solid};

  &:last-of-type {
    border: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const FieldHeading = styled(DisplaySmall)`
  margin-bottom: ${spacing.snug};
`;

// TODO: Use Field component from bazaar for this
export const FieldLabel = styled.label`
  display: block;
  margin-bottom: ${spacing.extraTight};
  color: ${color.theme.typography.ink};
  ${typography.label}
`;

export const FieldBody = styled(Body)`
  margin-bottom: ${spacing.snug};
`;

// TODO: This is duplicated
export const EquipList = styled.ul`
  margin: 0 0 ${spacing.snug} 0;
  padding-left: 0;

  li {
    margin-bottom: 6px;
  }

  li:empty {
    display: none;
  }
`;
